export default {
  LOBBY: 'lobby-fertility',
  SHAREPOINT: 'sharepoint',
  WILDFLOWER: 'wildflower',
  MYUHC: 'myuhc-empire',
  DEFAULT: 'unknown'
};
